import { useCallback, useState } from 'react';
import {
	patchBlock,
	patchBlockChat,
	patchMuteChat,
	patchUnblock,
	patchUnmute
} from './actions';
import { IRestrictObj, RestrictionsReturnType } from './types';

export function useRestrictions(): RestrictionsReturnType {
	const [loading, setLoading] = useState<boolean>(false);

	const unblockUser = useCallback(
		async (userId: number | string, onSuccess?: () => void) => {
			try {
				setLoading(true);
				const response = await patchUnblock(userId);
				if (response === 200) {
					onSuccess && onSuccess();
				}
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		 
		[]
	);

	const unmuteUser = useCallback(
		async (userId: number | string, onSuccess?: () => void) => {
			try {
				setLoading(true);
				const response = await patchUnmute(userId);
				if (response === 200) {
					onSuccess && onSuccess();
				}
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		 
		[]
	);

	const blockUser = useCallback(
		async (userId: number | string, restrictObj: IRestrictObj, onSuccess?: () => void) => {
			try {
				setLoading(true);
				const response = await patchBlock(userId, restrictObj);
				if (response === 200) {
					onSuccess && onSuccess();
				}
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		 
		[]
	);

	const blockChatUser = useCallback(
		async (
			userId: number | string,
			restrictObj: IRestrictObj,
			onSuccess?: (messages: string[]) => void
		) => {
			try {
				setLoading(true);
				const response = await patchBlockChat(userId, restrictObj);
				if (typeof response === 'object') {
					onSuccess && onSuccess(response?.messages);
				}
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		 
		[]
	);

	const muteChatUser = useCallback(
		async (
			userId: number | string,
			restrictObj: IRestrictObj,
			onSuccess?: (messages: string[]) => void
		) => {
			try {
				setLoading(true);
				const response = await patchMuteChat(userId, restrictObj);
				if (typeof response === 'object') {
					onSuccess && onSuccess(response?.messages);
				}
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		 
		[]
	);

	return {
		loading,
		blockUser,
		unblockUser,
		unmuteUser,
		blockChatUser,
		muteChatUser
	};
}
